import React , {Component} from 'react';
import AUX from '../../hoc/Aux_';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControl from '@material-ui/core/FormControl';
import {postDictionary, putDictionary } from '../../api/dictionary';
import Grid from '@material-ui/core/Grid';
import { InputLabel, Input, FormHelperText } from '@material-ui/core';
import { postCms } from '../../api/cms';


class AddCms extends Component{

  constructor(props) {
    super(props);
    this.state = {
      title : "",
      description: "",
      type:this.props.typenya
    };
  }

  handleChangeText = (keys,e) => {
      this.setState({ [keys]: e.target.value });
  };

  submitForm = () => {

    postCms(this.state)
    .then(response => {
        console.log(response);
        this.props.handleOpen(false);
        this.props.handleReload(true);
      })
      .catch(error => {
        console.log(error);
      });

  }

render(){
  return (
    <Grid item xs={12}  >
      <Grid item xs={12}>
        <FormControl>
          <InputLabel htmlFor="word">Title</InputLabel>
          <Input id="word" aria-describedby="word"
            value = {this.state.title}
            onChange = {(e) => this.handleChangeText("title",e)}
          />
        </FormControl>{' '}
        </Grid>
        <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel htmlFor="wordTarget">Description</InputLabel>
          <Input id="wordTarget" aria-describedby="wordTarget" fullWidth={true}
            value = {this.state.description}
            onChange = {(e) => this.handleChangeText("description",e)}
          />
        </FormControl>{' '}
        </Grid>
        <Grid item xs={6}>
 

      </Grid>
      <Grid item xs={6}>
      <br/>
        <Button variant="contained" color="primary" onClick = {this.submitForm}>Save</Button>

      </Grid>
    </Grid>
  )
}


}

export default AddCms;
